import * as style from './style.module.sass'

type InputLabelProps = {
  label: string
  required?: boolean
  design?: 'default' | 'large' | 'code' | 'gray'
}
const InputLabel = ({
  label,
  required = false,
  design = 'default',
}: InputLabelProps) => {
  return (
    <div className={style.label} data-design={design}>
      {label}
      {required && <span className={style.required}>必須</span>}
    </div>
  )
}

export default InputLabel
